import { render, staticRenderFns } from "./CookieConsent.vue?vue&type=template&id=0b3d8546&"
import script from "./CookieConsent.vue?vue&type=script&lang=js&"
export * from "./CookieConsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JVolke\\Documents\\plentyDevTool\\38722\\18\\KrauseSohn\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b3d8546')) {
      api.createRecord('0b3d8546', component.options)
    } else {
      api.reload('0b3d8546', component.options)
    }
    module.hot.accept("./CookieConsent.vue?vue&type=template&id=0b3d8546&", function () {
      api.rerender('0b3d8546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/pageDesign/CookieConsent.vue"
export default component.exports